import React, { useState } from "react";
import { Button } from "@twioku/common_components";
import { usePushSubscription } from "../pwa/usePushSubscription";
import { testSendPush } from "../api/push";
import { useAuth } from "../features/auth/hooks/useAuth";

// TODO: テストページなので検証後は削除する
export const PushNotificationTestPage: React.FC = () => {
    const { csrfToken } = useAuth();
    const { state, isSubscribed, isSubscribedLoading, subscribe, unsubscribe } =
        usePushSubscription(csrfToken);
    const [sendResult, setSendResult] = useState<string>("");
    const [isLoading, setIsLoading] = useState(false);

    const handleSubscribe = async () => {
        setIsLoading(true);
        const success = await subscribe();
        setSendResult(success ? "購読に成功しました" : "購読に失敗しました");
        setIsLoading(false);
    };

    const handleUnsubscribe = async () => {
        setIsLoading(true);
        await unsubscribe();
        setSendResult("購読を解除しました");
        setIsLoading(false);
    };

    const handleTestSend = async () => {
        setIsLoading(true);
        try {
            const result = await testSendPush(csrfToken);
            setSendResult(
                `送信結果: 成功=${result.success}, 失敗=${result.failed}`
            );
        } catch (error) {
            setSendResult(`送信エラー: ${error}`);
        }
        setIsLoading(false);
    };

    return (
        <div style={{ padding: "24px", maxWidth: "480px", margin: "0 auto" }}>
            <h1
                style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    marginBottom: "24px",
                }}
            >
                Push 通知テスト
            </h1>

            <div
                style={{
                    marginBottom: "16px",
                    padding: "16px",
                    background: "#f5f5f5",
                    borderRadius: "8px",
                }}
            >
                <p>
                    通知権限: <strong>{state}</strong>
                </p>
                <p>
                    購読状態:{" "}
                    <strong>
                        {isSubscribedLoading
                            ? "確認中…"
                            : isSubscribed
                              ? "購読中"
                              : "未購読"}
                    </strong>
                </p>
            </div>

            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                }}
            >
                {state === "unsupported" && (
                    <p style={{ color: "red" }}>
                        このブラウザは Push 通知に対応していません
                    </p>
                )}

                {state !== "unsupported" &&
                    !isSubscribed &&
                    !isSubscribedLoading && (
                        <Button onClick={handleSubscribe} disabled={isLoading}>
                            通知を有効にする
                        </Button>
                    )}

                {isSubscribed && (
                    <>
                        <Button onClick={handleTestSend} disabled={isLoading}>
                            テスト送信
                        </Button>
                        <Button
                            onClick={handleUnsubscribe}
                            disabled={isLoading}
                        >
                            通知を無効にする
                        </Button>
                    </>
                )}
            </div>

            {sendResult && (
                <div
                    style={{
                        marginTop: "16px",
                        padding: "12px",
                        background: "#e8f5e9",
                        borderRadius: "8px",
                    }}
                >
                    {sendResult}
                </div>
            )}
        </div>
    );
};
